import { combineReducers } from '@reduxjs/toolkit';
import { overlaySlice } from './overlay/overlay';

const overlayReducer = combineReducers({
  overlay: overlaySlice.reducer,
});

export default overlayReducer;
